import { useState, useEffect, useCallback } from 'react';
import { message } from 'antd';

export const useAdminUsers = ({ apiClasses }) => {
  const [adminUsers, setAdminUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAdminUsers = useCallback(async () => {
    if (!apiClasses?.TicketAPI?.getActiveAdminUsers) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await apiClasses.TicketAPI.getActiveAdminUsers();
      const { data } = response;

      if (data.success && data.payload) {
        setAdminUsers(data.payload);
      } else {
        throw new Error('Failed to fetch admin users');
      }
    } catch (err) {
      setError(err.message || 'Failed to fetch admin users');
      console.error('Error fetching admin users', err);
      message.error('Failed to fetch admin users');
    } finally {
      setLoading(false);
    }
  }, [apiClasses?.TicketAPI]);

  useEffect(() => {
    fetchAdminUsers();
  }, [fetchAdminUsers]);

  return {
    adminUsers,
    loading,
    error,
    refetch: fetchAdminUsers
  };
};

